import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Alert, IconButton } from '@mui/material';
import { Button } from 'components/index';
import { Close } from '@mui/icons-material';
import { Division, LineItemLabelEnum } from '../glossary/glossary.type';
import SelectDivisionFromGiven from '../glossary/SelectDivisionFromGiven';
import { useFormik } from 'formik';
import { ReportLineItemBulkEditFormValues } from './report.type';
import SelectInput from '../SelectInput';

interface LineItemsBulkEditDialogProps {
  open: boolean;
  onClose: () => void;
  divisions: Division[];
  onSubmit: (values: ReportLineItemBulkEditFormValues) => void;
}

const LineItemsBulkEditDialog: React.FC<LineItemsBulkEditDialogProps> = ({ open, onClose, divisions, onSubmit }) => {
  const labelsList = [
    { value: 'no-change', label: 'No Change' },
    ...Object.values(LineItemLabelEnum).map(label => ({ value: label, label })),
    { value: 'none', label: 'None' },
  ];

  const formik = useFormik({
    initialValues: {
      division: 'no-change',
      label: 'no-change',
    },
    enableReinitialize: true,
    onSubmit: values => {
      const updates: any = {};

      if (values.division !== 'no-change') {
        updates.division = values.division === 'none' ? null : divisions.find(division => division.id === values.division);
      }

      if (values.label !== 'no-change') {
        updates.label = values.label === 'none' ? null : values.label;
      }
      onSubmit(updates);
      formik.resetForm();
      onClose();
    },
  });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Edit Selected Line Items
        <IconButton onClick={onClose} style={{ position: 'absolute', right: '8px', top: '8px' }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Stack spacing={2} py={2}>
            <SelectDivisionFromGiven
              label='Division'
              divisions={divisions}
              selectedDivision={formik.values.division}
              setSelectedDivision={newVal => formik.setFieldValue('division', newVal)}
            />
            <SelectInput
              label='Label'
              selected={formik.values.label}
              setSelected={newVal => formik.setFieldValue('label', newVal)}
              list={labelsList}
            />
            <Alert severity='warning'>
              You need to click <b>Submit Changes</b> to avoid losing your changes!
            </Alert>
          </Stack>
        </form>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} color='error'>
          Cancel
        </Button>
        <Button variant='contained' color='primary' onClick={formik.submitForm}>
          Save Draft
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LineItemsBulkEditDialog;
